let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9xOM6")).then(() => parcelRequire('1Sm4w'));